import { render, staticRenderFns } from "./grapich-penduduk-home.vue?vue&type=template&id=34721fad"
import script from "./grapich-penduduk-home.vue?vue&type=script&lang=js"
export * from "./grapich-penduduk-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports